import React from 'react';

export default function SelectionHint() {
  const { getText } = Pollfish.ui;
  return (
    <div className="postal-code-selection-hint">
      {getText('selectLocation')}
    </div>
  );
}
